import { render, staticRenderFns } from "./iconForm.vue?vue&type=template&id=674a161b&scoped=true&"
import script from "./iconForm.vue?vue&type=script&lang=js&"
export * from "./iconForm.vue?vue&type=script&lang=js&"
import style0 from "./iconForm.vue?vue&type=style&index=0&id=674a161b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a161b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674a161b')) {
      api.createRecord('674a161b', component.options)
    } else {
      api.reload('674a161b', component.options)
    }
    module.hot.accept("./iconForm.vue?vue&type=template&id=674a161b&scoped=true&", function () {
      api.rerender('674a161b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/nine/components/iconForm.vue"
export default component.exports